import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AdminState {
  sideNavOpen: boolean;
  status: string;
  error: string;
  data: any;
  selectedItems: Array<any>;
  appliedFilters: Array<any>;
}

const initialState: AdminState = {
  sideNavOpen: false,
  status: "",
  error: "",
  data: [],
  selectedItems: [],
  appliedFilters: [],
};

const adminSlice = createSlice({
  name: "adminSlice",
  initialState,
  reducers: {
    setSideNavOpen: (state, action: PayloadAction<boolean>) => {
      state.sideNavOpen = action.payload;
    },
    updateAdminApprovalData: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
    },
    updateSelectedItems: (state, action: PayloadAction<Array<any>>) => {
      state.selectedItems = action.payload;
    },
    roleSelection: (state, action: PayloadAction<{ id: any; role: any }>) => {
      const copyState = JSON.parse(JSON.stringify(state));
      const result = copyState?.data?.map((item: any) => {
        if (item?.subrequest_id === action?.payload?.id) {
          return {
            ...item,
            selectedRoles: action?.payload?.role,
          };
        }
        return item;
      });
      state.data = result;
    },
    updateAppliedFilters: (state, action: PayloadAction<Array<any>>) => {
      state.appliedFilters = action.payload;
    },
    deleteAppliedFilters: (state, action: PayloadAction<string>) => {
      state.appliedFilters = state.appliedFilters.filter(
        (item) => item.field !== action.payload,
      );
    },
    openDropdown: (state, action: PayloadAction<any>) => {
      const copyState = JSON.parse(JSON.stringify(state));
      const newData = copyState?.data?.map((item: any) => {
        if (item?.subrequest_id === action?.payload) {
          return {
            ...item,
            rolesData: {
              ...item?.rolesData,
              isOpen: true,
            },
          };
        }
        return item;
      });
      state.data = newData;
    },
    closeDropdown: (state, action: PayloadAction<any>) => {
      const copyState = JSON.parse(JSON.stringify(state));
      const newData = copyState?.data?.map((item: any) => {
        if (item?.subrequest_id === action?.payload) {
          return {
            ...item,
            rolesData: {
              ...item?.rolesData,
              isOpen: false,
            },
          };
        }
        return item;
      });
      state.data = newData;
    },
    selectDropdownOptions: (
      state,
      action: PayloadAction<{ id: any; selectedOptions: Array<any> }>,
    ) => {
      const copyState = JSON.parse(JSON.stringify(state));
      const newData = copyState?.data?.map((item: any) => {
        if (item?.subrequest_id === action?.payload.id) {
          return {
            ...item,
            rolesData: {
              ...item?.rolesData,
              selectedOptions: action?.payload?.selectedOptions,
            },
          };
        }
        return item;
      });
      state.data = newData;
    },
  },
});
export const {
  setSideNavOpen,
  updateAdminApprovalData,
  updateSelectedItems,
  roleSelection,
  updateAppliedFilters,
  deleteAppliedFilters,
  openDropdown,
  closeDropdown,
  selectDropdownOptions,
} = adminSlice.actions;
export default adminSlice.reducer;
